import md5 from 'md5';

import { Message } from '@bijie/react-bnb';
import Router from 'next/router';
import { gwGet, gwPost, getDeviceInfo } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import createBaseActions, { handleGwData, setPostBody, setGetParams } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import makeOrCacheApiReq from '../../utils/apiCache';
import bog from '../../utils/moreBog';
import { csrfMatches } from '../../utils/csrfMatches';
import { requestApiOrLoginRedirect } from '../../utils/makeApiRequest';

const {
  SET_SYMBOL_BY_ASSET,
  FETCH_USER_DIVIDENDS,
  FETCH_USER_DIVIDENDS_ERROR,
  SET_USER_DIVIDENDS,
  FETCH_ASSET_WITHDRAW_INFO,
  FETCH_ASSET_WITHDRAW_INFO_SUCCESS,
  FETCH_ASSET_WITHDRAW_INFO_FAILED,
  FETCH_ASSETS,
  FETCH_ASSETS_SUCCESS,
  FETCH_ASSETS_FAILED,
  FETCH_ASSET_INFO_SUCCESS,
  FETCH_ASSET_INFO_ERROR,
  FETCH_WITHDRAW_LIMIT_SUCCESS,
  FETCH_USER_ASSETS_BY_COIN_SUCCESS,
  APPLY_WITHDRAW_SUCCESS,
  FETCH_WITHDRAW_ADDRESS_SUCCESS,
  FETCH_WITHDRAW_ADDRESS_FAILED,
  GET_ASSET_MIN_TRADE_INFO,
} = actionTypes;

const setTradeSymbol = createBaseActions(SET_SYMBOL_BY_ASSET, 'symbols');
const setUserDividendsData = createBaseActions(SET_USER_DIVIDENDS, 'data');
const setAssets = createBaseActions(FETCH_ASSETS_SUCCESS, 'data');
const setAssetInfo = createBaseActions(FETCH_ASSET_INFO_SUCCESS, 'data');
const setWithdrawAddress = createBaseActions(FETCH_WITHDRAW_ADDRESS_SUCCESS, 'data');

export const fetchTradeSymbol = asset => async dispatch => {
  dispatch(setTradeSymbol());
  let result = await gwGet(
    `${API_PATH.GET_SYMBOL_BY_ASSET_API_PATH}?${setGetParams({ baseAsset: asset })}`
  );
  /*
  BAD CODE
  */
  if (asset === 'USDT') {
    result = [
      { baseAsset: 'BTC', quoteAsset: 'USDT' },
      { baseAsset: 'ETH', quoteAsset: 'USDT' },
      { baseAsset: 'BNB', quoteAsset: 'USDT' },
    ];
  } else result = handleGwData(result);
  dispatch(setTradeSymbol(result));
};

export const fetchUserDividends = (postData, locale) => async dispatch => {
  dispatch({ type: FETCH_USER_DIVIDENDS });
  try {
    const result = await gwPost(API_PATH.USER_DIVIDENDS_API_PATH, {
      locale,
      ...setPostBody(postData),
    });
    dispatch(setUserDividendsData({ data: handleGwData(result) || [], total: result.total }));
  } catch (error) {
    dispatch({ type: FETCH_USER_DIVIDENDS_ERROR, error });
  }
};

export const fetchWitdrawAssetInfo = asset => async dispatch => {
  dispatch({ type: FETCH_ASSET_WITHDRAW_INFO });
  try {
    const params = setGetParams({ asset });
    let result = await gwGet(`${API_PATH.GET_ASSET_INTO_API_PATH}?${params}`);
    result = handleGwData(result);
    dispatch({ type: FETCH_ASSET_WITHDRAW_INFO_SUCCESS, data: result });
  } catch (error) {
    dispatch({ type: FETCH_ASSET_WITHDRAW_INFO_FAILED, error });
  }
};

export const fetchAssetWithdraw = async req => {
  let result = [];
  try {
    const api = API_PATH.GET_NETWORK_COIN_ALL;
    result = await makeOrCacheApiReq(
      api,
      () => gwGet(api, null, req),
      res => res.success && Array.isArray(res.data)
    );
    result = handleGwData(result);
  } catch (error) {
    // nothing
  }
  return result;
};

export const fetchAllAssets = () => async dispatch => {
  dispatch({ type: FETCH_ASSETS });
  try {
    let result;
    result = await gwGet(API_PATH.GET_ALL_ASSETS_API_PATH);
    result = handleGwData(result);
    dispatch(setAssets(result));
  } catch (error) {
    dispatch({ type: FETCH_ASSETS_FAILED, error });
  }
};

export const fetchAllAssetsLogo = async () => {
  let result = {};
  try {
    result = await gwGet(API_PATH.GET_ALL_ASSETLOGO_API_PATH);
    result = handleGwData(result);
    result = result.reduce((pre, cur) => {
      pre[cur.asset] = cur.pic;
      return pre;
    }, {});
  } catch (error) {
    // nothing
  }
  return result;
};

export const fetchAssetInfo = () => async dispatch => {
  try {
    const data = await gwGet(API_PATH.ASSET_INFO_API);
    dispatch(setAssetInfo(data));
  } catch (error) {
    dispatch({ type: FETCH_ASSET_INFO_ERROR, error });
  }
};

export const fetchWithdrawAddress = () => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.GET_WITHDRAW_ADDRESS_LIST, {
      locale,
      ...setPostBody({}),
    });
    dispatch(setWithdrawAddress(result.data));
  } catch (error) {
    dispatch({ type: FETCH_WITHDRAW_ADDRESS_FAILED, error });
  }
};

export const deleteWithdrawAddress = data => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.DELETE_WITHDRAW_ADDRESS, {
      locale,
      ...setPostBody(data),
    });
    if (result.success) {
      dispatch(fetchWithdrawAddress());
      return;
    }
    Message.fail(result.message, 2);
  } catch (error) {
    bog.error(`Error: deleteWithdrawAddress error, message is ${error.message}`);
  }
};

export const updataWhitelist = (data, type) => async (dispatch, getState) => {
  const { locale } = getState();
  const api =
    type === 'add' ? API_PATH.ADD_TO_WHITELIST_API_PATH : API_PATH.REMOVE_FROM_WHITELIST_API_PATH;
  try {
    const result = await gwPost(api, {
      locale,
      ...setPostBody(data),
    });
    if (result.success) {
      type === 'add'
        ? Router.push(`/${locale}/usercenter/settings/security/add-to-whitelisted`)
        : Message.success('Success', 2);
      if (type !== 'add') dispatch(fetchWithdrawAddress());
      return Promise.resolve();
    }
    Message.fail(result.message, 2);
    return Promise.reject();
  } catch (error) {
    bog.error(`Error: error, message is ${error.message}`);
    return Promise.reject();
  }
};

export const fetchUserAssetsByCoin = params => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.GET_USER_ASSET_API, { locale, ...setPostBody(params) });
    dispatch({ type: FETCH_USER_ASSETS_BY_COIN_SUCCESS, data: result.data[0] });
  } catch (error) {
    bog.error(`Error: fetchUserAssetsByCoin error, message is ${error.message}`);
  }
};

export const fetchWithdrawLimit = () => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const data = await gwPost(API_PATH.FETCH_WITHDRAW_LIMIT_API_PATH, { locale, ...setPostBody() });
    dispatch({ type: FETCH_WITHDRAW_LIMIT_SUCCESS, data });
  } catch (error) {
    bog.error(`Error: fetchWithdrawLimit error, message is ${error.message}`);
  }
};

export const applyWithdraw = data => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    if (typeof data !== 'object') throw new Error('Expected an object');

    const params = new URLSearchParams();
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, val] of Object.entries(data)) {
      params.set(key, val);
    }
    const postData = {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        csrftoken: md5(csrfMatches()[1]),
        clienttype: 'web',
        lang: locale,
        ...(await getDeviceInfo()),
      },
      body: params,
    };

    const res = await requestApiOrLoginRedirect(API_PATH.APPLY_WITHDRAW_API_PATH, null, postData);
    const { success, msg, id } = res;
    if (success) {
      dispatch({ type: APPLY_WITHDRAW_SUCCESS, data: msg });
      Router.pushRoute(`/${locale}/usercenter/wallet/withdrawals-email-verification/${id}`);
      return Promise.resolve();
    }
    Message.fail(msg, 2);
    return Promise.reject();
  } catch (error) {
    bog.error(`Error: applyWithdraw error, message is ${error.message}`);
    return Promise.reject();
  }
};

export const withdrawResendEmail = params => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.WITHERAW_RESEND_EMAIL_API_PATH, {
      locale,
      ...setPostBody(params),
    });
    if (!result.success) {
      Message.fail(result.message, 2);
    }
  } catch (error) {
    bog.error(`Error: withdrawResendEmail error, message is ${error.message}`);
  }
};

export const withdrawCancel = params => async (dispatch, getState) => {
  const { locale } = getState();
  try {
    const result = await gwPost(API_PATH.WITHERAW_CANCEL_API_PATH, {
      locale,
      ...setPostBody(params),
    });
    if (result.success) {
      Message.success('success', 2);
      return;
    }
    Message.fail(result.message, 2);
    return;
  } catch (error) {
    bog.error(`Error: withdrawCancel error, message is ${error.message}`);
  }
};

export const getAssetMinTradeInfo = params => async (dispatch) => {
  try {
    const result = await gwGet(`${API_PATH.USER_MIN_TRADE_INFO_PAI_PATH}?${setGetParams(params)}`);

    dispatch({ type: GET_ASSET_MIN_TRADE_INFO, data: result.data });
  } catch (error) {
    bog.error(`Error: withdrawCancel error, message is ${error.message}`);
  }
};
export default {};
